var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuTemplateGruppi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.82,102.4H102.4C45.85,102.4,0,148.25,0,204.8v614.4c0,56.32,46.08,102.4,102.4,102.4h819.2c56.32,0,102.4-46.08,102.4-102.4v-512c0-56.83-46.08-102.4-102.4-102.4h-365.82c-28.03,0-54.92-11.14-74.74-30.96l-40.48-40.48c-19.82-19.82-46.71-30.96-74.74-30.96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTemplateGruppi);
export default __webpack_public_path__ + "static/media/menu-template-gruppi.b51275c0ae2a2dfe20e8875cb4271b92.svg";
export { ForwardRef as ReactComponent };